// extracted by mini-css-extract-plugin
module.exports = {"container":"customer-list-container__1Ei5r"};